import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import ProductImages from './ProductImages';

const ChangePrioritiesMutation = gql`
    mutation changePriorities($imagesToChange: [PrioritiesInput!]!) {
        changePriorities(imagesToChange: $imagesToChange)
    }
`;

export default compose(graphql<any, Response>(ChangePrioritiesMutation, { name: 'changePriorities' }))(ProductImages);



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductImagesTab/ProductImages/index.ts